import {Form} from "../Support/Form";

export class ReportIndexes extends Form {

    constructor(data = {}) {
        super(data);
    }

    index(append = false) {
        return this.loadIndexData('/retail/report', append);
    }

}
